import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { TableColumn } from '@smartera/core';
import { RenderPipe, SmartyCurrencyPipe } from '@smartera/pipes';
import { Tooltip } from 'primeng/tooltip';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Component({
	selector: 'sis-col-value',
	templateUrl: './sis-col-value.component.html',
	styleUrls: ['./sis-col-value.component.scss'],
	imports: [CommonModule, Tooltip, TranslateModule, RenderPipe, SmartyCurrencyPipe],
})
export class SisColValueComponent implements OnInit {
	@Input() public col: TableColumn<any>;
	@Input() public rowData: any;

	protected value: any;

	ngOnInit(): void {
		if (this.isColFieldNested) {
			this.value = this.prepareNestedValue(this.rowData, this.col.field.toString());
		} else {
			this.value = this.rowData[this.col.field];
		}
	}

	private get isColFieldNested(): boolean {
		return this.col.field.toString().split('.').length > 1;
	}

	private prepareNestedValue(rowData: any, path: string): any {
		if (!rowData || !path) {
			return null;
		}

		// Split the path by dots
		const properties: string[] = path.split('.');
		let safeValue = rowData;

		// Traverse the object following the path
		for (const prop of properties) {
			if (safeValue === null || safeValue === undefined) {
				return null;
			}
			safeValue = safeValue[prop];
		}

		return safeValue;
	}
}
